function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M443.38 326.52C442.91 324.503 442.865 322.41 443.249 320.375C443.633 318.34 444.437 316.407 445.61 314.7C462.981 289.719 470.861 259.356 467.83 229.08L461.62 167C461.62 167 430.53 162.34 437.18 224.09L422.82 238.09L387.13 104.89C384.77 96 375.9 90.32 367 92.38C364.805 92.8895 362.734 93.8355 360.912 95.1617C359.09 96.4879 357.553 98.1671 356.394 100.099C355.234 102.032 354.475 104.178 354.161 106.409C353.848 108.641 353.987 110.913 354.57 113.09L345.16 78C344.576 75.8244 343.561 73.7884 342.174 72.0132C340.788 70.2379 339.058 68.7596 337.089 67.6662C335.119 66.5728 332.95 65.8867 330.71 65.6485C328.47 65.4104 326.205 65.6251 324.05 66.28C319.856 67.6362 316.348 70.5605 314.259 74.4422C312.17 78.3238 311.661 82.8624 312.84 87.11L322.14 121.83C321.562 119.647 320.549 117.602 319.163 115.819C317.777 114.036 316.045 112.55 314.072 111.451C312.098 110.353 309.924 109.663 307.678 109.424C305.432 109.185 303.16 109.401 301 110.06C296.806 111.416 293.298 114.341 291.209 118.222C289.12 122.104 288.611 126.642 289.79 130.89L300.18 169.66C299.591 167.491 298.572 165.463 297.184 163.695C295.797 161.928 294.068 160.456 292.101 159.369C290.135 158.282 287.969 157.6 285.734 157.365C283.499 157.13 281.24 157.346 279.09 158C270.36 160.65 265.52 170 267.89 178.83L269.89 186.28L272.13 194.62L298.39 292.62C303.735 312.588 313.852 330.958 327.87 346.15C329.573 348.003 330.781 350.256 331.38 352.7L334.85 367L445.85 337.25L443.38 326.52Z",
  className: "primary-lightened-1"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M353.99 109.62L381.39 212.55",
  className: "primary-stroke",
  strokeWidth: 6,
  strokeMiterlimit: 10
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M321.55 118.31L349.32 222.6",
  className: "primary-stroke",
  strokeWidth: 6,
  strokeMiterlimit: 10
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M438.33 223.18C438.33 223.18 418.47 237.37 410.49 257.26",
  className: "primary-stroke",
  strokeWidth: 6,
  strokeMiterlimit: 10
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M328.075 407.245L473.331 368.324L463.521 331.715L318.265 370.637L328.075 407.245Z",
  className: "secondary"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M316.4 184.62C314.245 183.962 311.979 183.745 309.738 183.981C307.497 184.217 305.326 184.902 303.356 185.994C301.385 187.087 299.654 188.565 298.267 190.341C296.879 192.117 295.864 194.153 295.28 196.33L305.67 157.56C306.848 153.312 306.34 148.774 304.251 144.892C302.162 141.011 298.654 138.086 294.46 136.73C292.305 136.074 290.039 135.858 287.799 136.095C285.559 136.333 283.389 137.019 281.419 138.112C279.449 139.206 277.72 140.685 276.334 142.461C274.947 144.237 273.933 146.274 273.35 148.45L282.65 113.73C283.828 109.482 283.32 104.944 281.231 101.062C279.142 97.1805 275.634 94.2562 271.44 92.9C269.285 92.2437 267.019 92.0278 264.779 92.2653C262.539 92.5028 260.369 93.1888 258.399 94.2824C256.429 95.376 254.7 96.8548 253.314 98.6308C251.927 100.407 250.913 102.444 250.33 104.62L240.91 139.76C241.493 137.583 241.632 135.311 241.318 133.079C241.005 130.848 240.246 128.702 239.086 126.769C237.926 124.837 236.39 123.158 234.568 121.832C232.746 120.506 230.675 119.56 228.48 119.05C219.59 116.99 210.72 122.68 208.36 131.49L171.58 268.74L158.31 250.74C164.96 188.99 133.87 193.65 133.87 193.65L127.66 255.75C124.661 285.677 132.325 315.702 149.3 340.53C150.564 342.385 151.394 344.5 151.728 346.72C152.062 348.939 151.892 351.205 151.23 353.35L148.23 362.98L259.92 392.9L264.37 378.44C265.022 376.331 266.135 374.394 267.63 372.77C281.648 357.578 291.765 339.208 297.11 319.24L323.37 221.24L325.61 212.9L327.61 205.45C330 196.64 325.13 187.27 316.4 184.62Z",
  className: "secondary"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M241.5 136.28L214.1 239.22",
  className: "secondary-darkened-1-stroke",
  strokeWidth: 6,
  strokeMiterlimit: 10
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M273.93 144.98L246.17 249.26",
  className: "secondary-darkened-1-stroke",
  strokeWidth: 6,
  strokeMiterlimit: 10
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M296.03 192.22L278.61 257.96",
  className: "secondary-darkened-1-stroke",
  strokeWidth: 6,
  strokeMiterlimit: 10
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M277.735 397.672L131.63 358.523L121.763 395.344L267.869 434.493L277.735 397.672Z",
  className: "primary-lightened-1"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M443 118V104",
  stroke: "#39473F",
  strokeWidth: 6,
  strokeMiterlimit: 10
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M517 193H531",
  stroke: "#39473F",
  strokeWidth: 6,
  strokeMiterlimit: 10
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M494.95 139.52L504.66 129.81",
  stroke: "#39473F",
  strokeWidth: 6,
  strokeMiterlimit: 10
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M158 140V126",
  stroke: "#39473F",
  strokeWidth: 6,
  strokeMiterlimit: 10
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M105.05 161.88L95.34 152.17",
  stroke: "#39473F",
  strokeWidth: 6,
  strokeMiterlimit: 10
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M83 215H69",
  stroke: "#39473F",
  strokeWidth: 6,
  strokeMiterlimit: 10
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M277.74 397.68L267.87 434.5L121.76 395.35L277.74 397.68Z",
  className: "primary"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M318.26 370.64L328.07 407.25L473.33 368.33L318.26 370.64Z",
  className: "secondary-darkened-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 600,
    height: 500,
    viewBox: "0 0 600 500",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

export default __webpack_public_path__ + "static/media/high_five.db092857.svg";
export { SvgComponent as ReactComponent };